import { createContext, useContext, ReactNode } from 'react';

/* Whether the app's navbar/bottom tab bar are currently hidden (scrolled away). The bars are
   fixed overlays that only ever translate out of view — `#main-container` keeps a constant
   `padding-top` reserved for the navbar (see layout.module.scss) so its own box never resizes
   mid-scroll. Pages that pin their own sub-navigation with `position: sticky` sit inside that
   padding and need this flag to pull themselves up into the space the navbar vacates, or
   they're left with a blank gap where the navbar used to be. */
const BarsVisibilityContext = createContext(false);

export const BarsVisibilityProvider = ({
  hidden,
  children,
}: {
  hidden: boolean;
  children: ReactNode;
}) => <BarsVisibilityContext.Provider value={hidden}>{children}</BarsVisibilityContext.Provider>;

export const useBarsHidden = () => useContext(BarsVisibilityContext);
